import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransfer = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "transfer-icon",
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .secc1 {\n        fill: #0573A9;\n      }\n    " }) }), /* @__PURE__ */ _jsx("path", {
		className: "secc1",
		d: "M7,.05029C3.271.05029.3501,2.97119.3501,6.7002c0,3.72852,2.9209,6.64941,6.6499,6.64941,3.72852,0,6.64941-2.9209,6.64941-6.64941C13.64941,2.97119,10.72852.05029,7,.05029ZM7,12.25c-2.20636,0-4.06866-1.22803-4.96893-3.04999h3.16895v1.79999l2.39996-2.5-2.39996-2.5v2H1.60272c-.09656-.41638-.15302-.84985-.15302-1.2998C1.44971,3.58789,3.8877,1.1499,7,1.1499c2.24622,0,4.13531,1.27332,5.01587,3.15009h-3.21588v-1.79999l-2.39996,2.5,2.39996,2.5v-2h3.62189c.08203.3858.12793.78644.12793,1.2002,0,3.1123-2.4375,5.5498-5.5498,5.5498Z"
	})]
});
export default SvgTransfer;
